import type React from 'react';

import { useAppSelector } from 'src/hooks/redux-hooks';

import MessageFooter from 'src/components/job-slide-out/components/nav-table/message/footer';
import SideBar from 'src/components/job-slide-out/components/nav-table/message/side-bar';
import ChatSection from 'src/components/job-slide-out/components/nav-table/message/chat-section';

const Message: React.FC = () => {
  const customerMessageConfig = useAppSelector(
    (state) => state?.jobDetails?.data?.customer_message,
  ) as Record<string, unknown> | undefined;

  return (
    <div className="message-wrapper">
      {customerMessageConfig?.has_multiple_threads
        ? (
          <SideBar />
        ) : ''}
      <div className="message-outer">
        <ChatSection />
        <MessageFooter />
      </div>
    </div>
  );
};
export default Message;
